import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0f27b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "pa-2 text-center" }

import {computed, getCurrentInstance, ref, watch} from 'vue';
import {RouteLocationRaw, RouteRecordRaw} from 'vue-router';
import router from './router';
import {useApplicationState} from './store/applicationState';
import {SplashScreen} from '@capacitor/splash-screen';
import {asyncRef, doAlert, doConfirm} from './util';
import {Device} from '@capacitor/device';
import FilterBtn from './components/FilterBtn.vue';
import Settings from '@/views/Settings.vue';
import {useSettings} from './store/settings';
import {storeMap} from './plugins/piniaStoreById';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {

const settingsStore = useSettings();
const drawer = ref(false);
const instance = getCurrentInstance();
const appVersion = ref(process.env.VUE_APP_PACKAGE_VERSION || 'dirty');

const routes = computed((): readonly RouteRecordRaw[] => router.options.routes ?? []);
const showSettingsOverlay = ref(false);

const isSlowDevice = asyncRef(true, async () => {
  const info = await Device.getInfo();
  if (info.platform !== 'android') return false;
  const versionParts = info.webViewVersion.split('.');
  const majorVersion = parseInt(versionParts[0]);
  console.log({
    versionParts,
    majorVersion,
  });
  if (majorVersion >= 70) {
    return false;
  }

  return true;
});

const isMobile = asyncRef(true, async () => {
  const info = await Device.getInfo();
  return info.platform == 'android' || info.platform == 'ios';
});

const isIos = asyncRef(true, async () => {
  const info = await Device.getInfo();
  return info.platform == 'ios';
});

const logout = async () => {
  if (!await doConfirm('Wollen Sie sich wirklich abmelden?', 'Wirklich abmelden?', {
    ok: 'Ja',
    cancel: 'Nein',
  })) return;
  await settingsStore.logout();
};
const isAuthenticated = computed(() => {
  return settingsStore.userToken !== null;
});

const route = computed((() => instance?.proxy?.$route));
const group = computed({
  get(): string | null {
    return route.value?.matched[0]?.name as string ?? null;
  },
  set(val: string | null) {
    drawer.value = false;
    router.push({name: val!});
  },
});

const canGoBack = computed(() => {
  return route.value?.meta?.canGoBack as boolean;
});

SplashScreen.hide().catch(console.error);

async function refreshCurrent() {
  try {
    const store = storeMap.get(route.value?.meta?.module as string);
    await store?.fetch();
  } catch (err: any) {
    await doAlert(err.message ?? err, 'Fehler');
  }
}

watch(showSettingsOverlay, (isShown) => {
  if (isShown) return;
  refreshCurrent().catch(console.error);
});

const applicationState = useApplicationState();

function stringify(data: any) {
  return JSON.stringify(data) + ' ';
}

function navigate(to: RouteLocationRaw) {
  router.push(to).catch(console.error);
}

const appClasses = computed(() => {
  if (isSlowDevice.value) {
    return 'no-transistion';
  }

  if (isIos.value) {
    return 'use-safe-area';
  }

  return '';
});

__expose({
  drawer,
  canGoBack,
  routes,
  group,
  logout,
  appVersion,
  isAuthenticated,
  isSlowDevice,
  showSettingsOverlay,
  stringify,
  navigate,
  applicationState,
  refreshCurrent,
  settingsStore,
  FilterBtn,
  Settings,
});


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: _normalizeClass(appClasses.value)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
        temporary: ""
      }, {
        append: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, " v" + _toDisplayString(appVersion.value), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'changePassword' }))),
                lines: "two"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('@/assets/service-erp.svg')
                      }, null, 8, _hoisted_1)
                    ], undefined, true),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(settingsStore).sessionData?.Bediener.Name ?? _unref(settingsStore).username), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(settingsStore).sessionData?.Mandant.find((mandant) => mandant.MandantNr === _unref(settingsStore).client)?.Name), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_list, {
            modelValue: group.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((group).value = $event)),
            nav: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: route.name
                }, [
                  (!route.meta?.hideInNav)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        value: route.name,
                        link: "",
                        to: route
                      }, _createSlots({
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(route.meta?.icon ?? ''), 1)
                            ], undefined, true),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(route.meta?.title ?? route.name), 1)
                            ], undefined, true),
                            _: 2
                          }, 1024)
                        ], undefined, true),
                        _: 2
                      }, [
                        (route.meta?.badgeContent)
                          ? {
                              name: "append",
                              fn: _withCtx(() => [
                                _createVNode(_component_v_badge, {
                                  inline: "",
                                  content: (route.meta?.badgeContent as string | number)
                                }, null, 8, ["content"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["value", "to"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createVNode(_component_v_list_item, { onClick: logout }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-logout")
                    ], undefined, true),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Abmelden ")
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }, 8, ["modelValue"])
        ], undefined, true),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_app_bar, {
        id: "mainAppBar",
        color: "primary",
        theme: "dark",
        density: _unref(isMobile) ? 'default' : 'compact'
      }, {
        default: _withCtx(() => [
          (canGoBack.value && _ctx.$route.matched.length > 1)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.back()), ["stop"])),
                icon: "",
                style: {"z-index":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-arrow-left")
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }))
            : (isAuthenticated.value)
              ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_v_toolbar_title, { class: "flex-fill" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(applicationState).title), 1)
            ], undefined, true),
            _: 1
          }),
          (_ctx.$route.meta?.module)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                icon: "",
                style: {"z-index":"1"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showSettingsOverlay.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-cog")
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.$route.meta?.module)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 3,
                icon: "",
                onClick: refreshCurrent
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-refresh")
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      }, 8, ["density"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ], undefined, true),
        _: 1
      }),
      (_ctx.$route.meta?.filter)
        ? (_openBlock(), _createBlock(FilterBtn, {
            key: 0,
            "fixed-bottom": ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showSettingsOverlay.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showSettingsOverlay).value = $event)),
        fullscreen: !_unref(isIos)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "primary",
                theme: "dark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Einstellungen")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_toolbar_items, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (showSettingsOverlay.value = false)),
                        icon: "",
                        style: {"z-index":"1"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-close")
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(Settings, {
                    onSave: _cache[7] || (_cache[7] = ($event: any) => (showSettingsOverlay.value = false))
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }, 8, ["modelValue", "fullscreen"])
    ], undefined, true),
    _: 1
  }, 8, ["class"]))
}
}

})